import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    templateUrl: './schedule-route-trip-page.component.html'
})
export class ScheduleRouteTripPageComponent extends BaseComponent implements OnInit, OnDestroy {
    routeId = null;
    directionId = null;
    stopId = null;
    tripId = null;
    constructor(private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.routeId = params['routeId'];
            this.directionId = params['directionId'];
            this.stopId = +params['stopId'];
            this.tripId = params['tripId'];
        });
    }
}
